var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosError } from "axios";
import { call, getContext, put, takeEvery, takeLatest, cancelled, } from "redux-saga/effects";
import { ManageUser } from "../constants/manage_users";
import { APIType } from "../services/authenticationService";
// Track the current request to prevent race conditions
var currentCaseloadRequestId = 0;
var currentDashboardRequestId = 0;
function fetchCaseload(action) {
    var callAPI, requestId, response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getContext("authService")];
            case 1:
                callAPI = (_a.sent()).callAPI;
                requestId = ++currentCaseloadRequestId;
                _a.label = 2;
            case 2:
                _a.trys.push([2, 6, 9, 11]);
                return [4 /*yield*/, call(function () {
                        return callAPI(APIType.GET, "/api/get_caseload/", {
                            params: {
                                user: action.username,
                            },
                        });
                    })];
            case 3:
                response = _a.sent();
                if (!(requestId === currentCaseloadRequestId && response)) return [3 /*break*/, 5];
                return [4 /*yield*/, put({
                        type: ManageUser.ManageUser_Sucessful,
                        payload: response.data,
                    })];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [3 /*break*/, 11];
            case 6:
                error_1 = _a.sent();
                if (!(requestId === currentCaseloadRequestId)) return [3 /*break*/, 8];
                console.error("Error fetching caseload:", error_1);
                return [4 /*yield*/, put({
                        type: ManageUser.ManageUser_Error,
                        payload: error_1,
                    })];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8: return [3 /*break*/, 11];
            case 9: return [4 /*yield*/, cancelled()];
            case 10:
                if (_a.sent()) {
                    console.log("Caseload request cancelled");
                }
                return [7 /*endfinally*/];
            case 11: return [2 /*return*/];
        }
    });
}
function fetchCaseloadDashboard(action) {
    var callAPI, requestId, response, error_2;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, getContext("authService")];
            case 1:
                callAPI = (_b.sent()).callAPI;
                requestId = ++currentDashboardRequestId;
                _b.label = 2;
            case 2:
                _b.trys.push([2, 6, 14, 16]);
                return [4 /*yield*/, call(function () {
                        return callAPI(APIType.GET, "/api/get_fields_for_user/", {
                            params: { user: action.username },
                        });
                    })];
            case 3:
                response = _b.sent();
                if (!(requestId === currentDashboardRequestId && response)) return [3 /*break*/, 5];
                return [4 /*yield*/, put({
                        type: ManageUser.ManageUserDashboard_Sucessful,
                        payload: response.data,
                    })];
            case 4:
                _b.sent();
                _b.label = 5;
            case 5: return [3 /*break*/, 16];
            case 6:
                error_2 = _b.sent();
                if (!(requestId === currentDashboardRequestId)) return [3 /*break*/, 13];
                if (!(error_2 instanceof AxiosError)) return [3 /*break*/, 11];
                if (!(((_a = error_2.response) === null || _a === void 0 ? void 0 : _a.status) === 400)) return [3 /*break*/, 8];
                return [4 /*yield*/, put({
                        type: ManageUser.ManageUserDashboard_Empty,
                    })];
            case 7:
                _b.sent();
                return [3 /*break*/, 10];
            case 8: return [4 /*yield*/, put({
                    type: ManageUser.ManageUserDashboard_Error,
                    payload: error_2,
                })];
            case 9:
                _b.sent();
                _b.label = 10;
            case 10: return [3 /*break*/, 13];
            case 11: return [4 /*yield*/, put({
                    type: ManageUser.ManageUserDashboard_Error,
                    payload: error_2,
                })];
            case 12:
                _b.sent();
                _b.label = 13;
            case 13: return [3 /*break*/, 16];
            case 14: return [4 /*yield*/, cancelled()];
            case 15:
                if (_b.sent()) {
                    console.log("Dashboard request cancelled");
                }
                return [7 /*endfinally*/];
            case 16: return [2 /*return*/];
        }
    });
}
function exportUsersData(action) {
    var callAPI, usersList, response, contentDisposition, filenameMatch, filename, blobUrl, link, error_3;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, getContext("authService")];
            case 1:
                callAPI = (_b.sent()).callAPI;
                usersList = {
                    users: action.payload,
                };
                _b.label = 2;
            case 2:
                _b.trys.push([2, 6, , 7]);
                return [4 /*yield*/, call(function () {
                        return callAPI(APIType.POST, "/api/export_data/", {
                            body: usersList,
                            responseType: "blob",
                        });
                    })];
            case 3:
                response = _b.sent();
                if (!response) return [3 /*break*/, 5];
                contentDisposition = (_a = response.headers["content-disposition"]) !== null && _a !== void 0 ? _a : "";
                filenameMatch = /filename="?([^"]+)"?/.exec(contentDisposition);
                filename = filenameMatch ? filenameMatch[1] : "user_data.xlsx";
                blobUrl = window.URL.createObjectURL(response.data);
                link = document.createElement("a");
                link.href = blobUrl;
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);
                return [4 /*yield*/, put({
                        type: ManageUser.ManageExportUsers_Sucessful,
                        payload: "Export downloaded successfully.",
                    })];
            case 4:
                _b.sent();
                _b.label = 5;
            case 5: return [3 /*break*/, 7];
            case 6:
                error_3 = _b.sent();
                console.error("Error exporting users data:", error_3);
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function archiveUsersData(action) {
    var callAPI, usersList, response, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getContext("authService")];
            case 1:
                callAPI = (_a.sent()).callAPI;
                usersList = {
                    users: action.payload,
                };
                _a.label = 2;
            case 2:
                _a.trys.push([2, 7, , 8]);
                return [4 /*yield*/, call(function () {
                        return callAPI(APIType.POST, "/api/archive_users/", { body: usersList });
                    })];
            case 3:
                response = _a.sent();
                if (!response) return [3 /*break*/, 6];
                return [4 /*yield*/, call(fetchCaseload, {
                        username: action.username,
                    })];
            case 4:
                _a.sent();
                return [4 /*yield*/, put({
                        type: ManageUser.ManageArchiveUsers_Sucessful,
                        payload: response.data.message,
                    })];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [3 /*break*/, 8];
            case 7:
                error_4 = _a.sent();
                console.error("Error archiving users data:", error_4);
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function deleteUsersData(action) {
    var callAPI, usersList, response, error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getContext("authService")];
            case 1:
                callAPI = (_a.sent()).callAPI;
                usersList = {
                    users: action.payload,
                };
                _a.label = 2;
            case 2:
                _a.trys.push([2, 7, , 8]);
                return [4 /*yield*/, call(function () {
                        return callAPI(APIType.POST, "/api/delete_users/", { body: usersList });
                    })];
            case 3:
                response = _a.sent();
                if (!response) return [3 /*break*/, 6];
                return [4 /*yield*/, call(fetchCaseload, {
                        username: action.username,
                    })];
            case 4:
                _a.sent();
                return [4 /*yield*/, put({
                        type: ManageUser.ManageDeleteUsers_Sucessful,
                        payload: response.data,
                    })];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [3 /*break*/, 8];
            case 7:
                error_5 = _a.sent();
                console.error("Error deleting users data:", error_5);
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function createNewUser(action) {
    var callAPI, body, response, error_6;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, getContext("authService")];
            case 1:
                callAPI = (_c.sent()).callAPI;
                body = __assign({ email: action.email, user: action.hierarchy }, action.params);
                _c.label = 2;
            case 2:
                _c.trys.push([2, 6, , 9]);
                return [4 /*yield*/, call(function () {
                        return callAPI(APIType.POST, "/api/generate_token/", { body: body });
                    })];
            case 3:
                response = _c.sent();
                if (!response) return [3 /*break*/, 5];
                return [4 /*yield*/, put({
                        type: ManageUser.ManageCreateUser_Successful,
                    })];
            case 4:
                _c.sent();
                _c.label = 5;
            case 5: return [3 /*break*/, 9];
            case 6:
                error_6 = _c.sent();
                if (!(error_6 instanceof AxiosError)) return [3 /*break*/, 8];
                return [4 /*yield*/, put({
                        type: ManageUser.ManageCreateUser_Error,
                        payload: (_b = (_a = error_6.response) === null || _a === void 0 ? void 0 : _a.data.error) !== null && _b !== void 0 ? _b : "Error creating.",
                    })];
            case 7:
                _c.sent();
                _c.label = 8;
            case 8: return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function forceBlrRecalculation(action) {
    var callAPI, response, error_7;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, getContext("authService")];
            case 1:
                callAPI = (_c.sent()).callAPI;
                _c.label = 2;
            case 2:
                _c.trys.push([2, 6, , 11]);
                return [4 /*yield*/, call(function () {
                        return callAPI(APIType.POST, "/api/force_blr_recalculation_all/", { body: {} });
                    })];
            case 3:
                response = _c.sent();
                if (!response) return [3 /*break*/, 5];
                return [4 /*yield*/, put({
                        type: ManageUser.ForceBlrRecalculation_Successful,
                        payload: response.data,
                    })];
            case 4:
                _c.sent();
                _c.label = 5;
            case 5: return [3 /*break*/, 11];
            case 6:
                error_7 = _c.sent();
                console.error("Error forcing BLR recalculation:", error_7);
                if (!(error_7 instanceof AxiosError)) return [3 /*break*/, 8];
                return [4 /*yield*/, put({
                        type: ManageUser.ForceBlrRecalculation_Error,
                        payload: (_b = (_a = error_7.response) === null || _a === void 0 ? void 0 : _a.data.error) !== null && _b !== void 0 ? _b : "Error forcing BLR recalculation.",
                    })];
            case 7:
                _c.sent();
                return [3 /*break*/, 10];
            case 8: return [4 /*yield*/, put({
                    type: ManageUser.ForceBlrRecalculation_Error,
                    payload: "Error forcing BLR recalculation.",
                })];
            case 9:
                _c.sent();
                _c.label = 10;
            case 10: return [3 /*break*/, 11];
            case 11: return [2 /*return*/];
        }
    });
}
export default function ManageUserSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: 
            // Use takeLatest to automatically cancel previous requests when new ones are made
            return [4 /*yield*/, takeLatest(ManageUser.ManageUser, fetchCaseload)];
            case 1:
                // Use takeLatest to automatically cancel previous requests when new ones are made
                _a.sent();
                return [4 /*yield*/, takeLatest(ManageUser.ManageUserDashboard, fetchCaseloadDashboard)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeEvery(ManageUser.ManageExportUsers, exportUsersData)];
            case 3:
                _a.sent();
                return [4 /*yield*/, takeEvery(ManageUser.ManageArchiveUsers, archiveUsersData)];
            case 4:
                _a.sent();
                return [4 /*yield*/, takeEvery(ManageUser.ManageDeleteUsers, deleteUsersData)];
            case 5:
                _a.sent();
                return [4 /*yield*/, takeEvery(ManageUser.ManageCreateUser, createNewUser)];
            case 6:
                _a.sent();
                return [4 /*yield*/, takeEvery(ManageUser.ForceBlrRecalculation, forceBlrRecalculation)];
            case 7:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
